import { makeStyles } from "@mui/styles";
import { AxiosError } from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import httpsService from "src/api/httpsService";
import ButtonCommon from "src/commonStyles/button/button";
import HeaderTitle from "src/commonStyles/text/headerTitle/headerTitle";
import { API_PATH } from "src/const/api-urls";
import { BaseResponse } from "src/interface";
import {
  IDataPolicy,
  IDataSelectFee,
  IInquiryPolicyResponse,
  IInquiryPolicyResponseData,
} from "src/interface/inforPay";
import PATH from "src/routes/route-path";
import PolicyInfo from "./component/policyInfo";
import SelectFee from "./component/selectFee";

const useStyle = makeStyles((theme) => {
  return {
    container: {
      paddingBottom: "24px",
      [theme.breakpoints.down("md")]: {
        paddingBottom: "0px",
      },
    },
  };
});
const Step2 = ({data, frSystm, callbackUrl}: {data: IInquiryPolicyResponseData, frSystm?: string, callbackUrl?: string}) => {
  const navigate = useNavigate();
  const classes = useStyle();
  const [dataFrAPI, setDataFromAPI] = useState<IInquiryPolicyResponseData>(data);
  const [dataToPolicyInfo, setDataToPolicyInfor] = useState<IDataPolicy>();
  const [dataToSelectFee, setDataToSelectFee] = useState<IDataSelectFee>();
  const [hasPolicy, setHasPolicy] = useState(false);
  const [loading, setLoading] = useState(false);

  const isShowBtnBack = frSystm === 'LAMB2';

  const setDataToPart = (data: IInquiryPolicyResponseData) => {
    const toPolicyInfo = {
      idNumber: data.idNumber,
      phName: data.phName,
      laName: data.laName,
      prdName: data.prdName,
      status: data.status,
      payFrequency: data.payFrequency,
      feeAmt: data.feeAmt,
    };
    const toSelectFee = {
      changePaymentFrequency: data.changePaymentFrequency,
      status: data.status,
      addRider: data.addRider,
      idNumber: data.idNumber,
      suspenseAmt: data.suspenseAmt,
      initialPremium: data.initialPremium,
      duePremium: data.duePremium,
      topup: data.topup,
      reinstate: data.reinstate,
    };
    setDataToPolicyInfor(toPolicyInfo);
    setDataToSelectFee(toSelectFee);
    setHasPolicy(data?.initialPremium?.totalAmt === null || !Boolean(data?.initialPremium?.totalAmt));
  };
  useEffect(() => {
    try {
      setDataToPart(dataFrAPI)

    } catch {

    } finally {
      setLoading(false)
    }
  }, []);

  return (
    <>
      {!loading && (
        <>
          <div className={classes.container}>
            <PolicyInfo dataPolicy={dataToPolicyInfo} frSystm={frSystm} hasPolicy={hasPolicy} isShowBtnBack={isShowBtnBack}/>
          </div>
          <div className={classes.container}>
            <SelectFee dataFee={dataFrAPI} hasPolicy={hasPolicy} frSystm={frSystm} callbackUrl={callbackUrl}/>
          </div>
        </>
      )}
    </>
  );
};
export default Step2;
